import React from "react";
import { Card } from "./shared";
import * as m from "../lib/model";
import { toast } from "sonner";

const fmtIn = (n) => (Number(n) ? Math.round(n).toLocaleString("en-US") : "");
const parse = (s) => +String(s).replace(/[^\d-]/g, "") || 0;

export function BlendedEbitdaCard({ M, setField }) {
  const b = m.blendedEbitda(M);
  const cur = M.ebitdaBlend || {};
  const write = (patch) => setField("ebitdaBlend", {
    labels: b.years.map((y) => y.label), values: b.years.map((y) => y.value), weights: b.years.map((y) => y.weight), ...cur, ...patch,
  });
  const setYear = (i, k, v) => {
    const arr = b.years.map((y) => y[k]);
    arr[i] = v;
    write({ [k === "value" ? "values" : k === "weight" ? "weights" : "labels"]: arr });
  };
  const linked = Math.abs((M.sde || 0) - b.value) < 1 && b.value > 0;
  const diff = b.value - (M.sde || 0);
  const apply = () => { setField("sde", Math.round(b.value)); toast.success(`Model EBITDA set to ${m.fmt$(Math.round(b.value))} (blended)`); };
  return (
    <Card title="Blended EBITDA — 3-Year Weighted" testid="blend-card"
      right={<span style={{ fontSize: 10.5, color: "var(--text3)", fontStyle: "italic" }}>{b.seeded ? "seeded from historical P&L" : "manual inputs"}</span>}>
      <div className="blend-list" data-testid="blend-table">
        {b.years.map((y, i) => (
          <div className="blend-line" key={i} data-testid={`blend-row-${i}`}>
            <div className="blend-cell">
              <label>Period</label>
              <input className="inp blend-lbl" value={y.label} onChange={(e) => setYear(i, "label", e.target.value)} data-testid={`blend-label-${i}`} />
              <span className="blend-hint">{i === 0 ? "most recent full year" : i === 1 ? "prior year" : "two years prior"}</span>
            </div>
            <div className="blend-cell">
              <label>EBITDA / Adj. SDE</label>
              <div className="money-input ru-money" style={{ display: "flex" }}><span className="cur">$</span><input className="inp mono" inputMode="numeric" placeholder="0" style={{ width: "100%", textAlign: "right" }} value={fmtIn(y.value)} onFocus={(e) => e.target.select()} onChange={(e) => setYear(i, "value", parse(e.target.value))} data-testid={`blend-value-${i}`} /></div>
            </div>
            <div className="blend-cell blend-cell-w">
              <label>Weight</label>
              <div className="blend-w"><input className="inp mono" type="number" min={0} max={100} step={5} value={y.weight} onChange={(e) => setYear(i, "weight", +e.target.value)} data-testid={`blend-weight-${i}`} /><span>%</span></div>
            </div>
            <div className="blend-cell blend-cell-c">
              <label>Contribution</label>
              <div className="blend-contrib mono">{m.fmt$(b.wSum > 0 ? (y.value * y.weight) / b.wSum : 0)}</div>
            </div>
          </div>
        ))}
        <div className="blend-line blend-total" data-testid="blend-total">
          <div className="blend-cell"><label>Result</label><span className="blend-title">Blended EBITDA</span><span className="blend-hint">weighted average of the three periods</span></div>
          <div className="blend-cell" />
          <div className="blend-cell blend-cell-w"><label>Total weight</label><div className={`mono ${b.wSum === 100 ? "" : "neg"}`} style={{ fontSize: 13, padding: "6px 0" }}>{b.wSum}%{b.wSum !== 100 && " (normalized)"}</div></div>
          <div className="blend-cell blend-cell-c"><label>Blended</label><div className="blend-val mono pos" data-testid="blend-value">{m.fmt$(b.value)}</div></div>
        </div>
      </div>
      <div className="blend-foot">
        <span className="ra-sub" data-testid="blend-diff">
          {linked ? "Model EBITDA is using the blended figure." : <>Stated EBITDA {m.fmt$(M.sde || 0)} · blended is <b className={diff >= 0 ? "pos" : "neg"}>{diff >= 0 ? "+" : ""}{m.fmt$(diff)}</b> {diff >= 0 ? "higher" : "lower"}</>}
        </span>
        <div style={{ display: "flex", gap: 8 }}>
          {!b.seeded && <button className="btn btn-sm" onClick={() => setField("ebitdaBlend", undefined)} data-testid="blend-reset">Reset to P&L</button>}
          <button className="btn btn-sm btn-primary" onClick={apply} disabled={linked || !(b.value > 0)} data-testid="blend-apply">Use blended as model EBITDA</button>
        </div>
      </div>
    </Card>
  );
}
